import { render, staticRenderFns } from "./test_aiplatform.vue?vue&type=template&id=114af356&"
import script from "./test_aiplatform.vue?vue&type=script&lang=js&"
export * from "./test_aiplatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports